export default {
  styles: null,
  value: {
    type: [Object, Array],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  choiceSideModalTitle: {
    type: String,
    default: '选择注册证号',
  },
  sideModalWidth: {
    type: String,
    default: '400',
  },
  urlQuery: {
    type: String,
    default: '',
  },
  tableColumnDefUrl: {
    type: String,
    default: '',
  },
  draggableOfHeader: {
    type: Boolean,
    default: false,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  chooseRequestMethod: {
    type: String,
    default: 'post',
  },
  goodsId: {
    type: String,
    default: null,
  },
  chooseRequestParam: {
    type: [String, Object],
    default: () => {},
  },
  criteriaFormUrl: {
    type: String,
    default: '',
  },
  showKey: {
    type: String,
    default: 'code',
  },
  showKeySubFlag: {
    type: Boolean,
    default: false,
  },
  showKeySubtitle: {
    type: String,
    default: 'name',
  },
  placeholder: {
    type: String,
    default: '证照类型',
  },
  showOfSearchInput: {
    type: Boolean,
    default: false,
  },
  //
  searchKey: {
    type: String,
    default: 'keyword',
  },
  begFormData: {
    // queryGroup查询组绑定的数据
    type: Object,
  },
  emdedKey: {
    type: String,
    default: 'warehouse',
  },
  showAbleClearText: {
    type: Boolean,
    default: true,
  },
  showSlot: {
    type: Boolean,
    default: true,
  },
  isShowModal: {
    type: Boolean,
    default: false,
  },
  dataParams: {
    type: Object,
    default: () => {},
  },
  pamamsUrl: {
    type: String,
    default: '',
  },
  chooseBtnText: {
    type: String,
    default: '选择',
  },
  controlSwitch: {
    type: Boolean,
    default: false,
  },
  beforeContentMsg: {
    type: String,
    default: '确认调整货位？',
  },
  afterContentMsg: {
    type: String,
    default: '货位已调整，',
  },
  btnIsGrayed: {
    type: String,
    default: 'grayed',
  },
  btnIsDisabledCode: {
    type: String,
    default: 'selected',
  },
  iconSelection: {
    type: Boolean,
    default: true,
  },
  defaultTipMessage: {
    //是否显示默认的结果信息
    type: Boolean,
    default: false,
  },
  paramsName: {
    type: String, //提交参数可以配置
    default: 'location',
  },
  addDataKey: {
    //是否开启传递参数单独的参数
    type: Boolean,
    default: false,
  },
  addDataKeyId: {
    type: String, //请求方法
    default: 'parentIds',
  },
  method: {
    type: String, //请求方法
    default: 'post',
  },
  showMessage: {
    //是否显示提示框
    type: Boolean,
    default: true,
  },
  dispatchComponent: {
    type: [Object], //动态更新组件
    default: () => ({}),
  },
  formData: {
    //表格数据
    type: [Object, Array],
  },
}
